import { TransactionSort } from "@boo/shared";
import type {
  ExpenseCategory,
  TransactionSource,
  TransactionType,
} from "@boo/shared";

export interface TransactionFilters {
  title: string;
  category: ExpenseCategory | null;
  transactionType: TransactionType | null;
  source: TransactionSource | null;
  /** Only rows with no account. */
  unassigned: boolean;
  /** Only rows sent from or received into this account. */
  accountId: string | null;
}

export const EMPTY_TRANSACTION_FILTERS: TransactionFilters = {
  title: "",
  category: null,
  transactionType: null,
  source: null,
  unassigned: false,
  accountId: null,
};

export const SORT_LABELS: Record<TransactionSort, string> = {
  [TransactionSort.DateDesc]: "Newest first",
  [TransactionSort.DateAsc]: "Oldest first",
  [TransactionSort.AmountDesc]: "Amount: high to low",
  [TransactionSort.AmountAsc]: "Amount: low to high",
};

export function hasActiveFilter(f: TransactionFilters): boolean {
  return (
    f.title.trim() !== "" ||
    f.category !== null ||
    f.transactionType !== null ||
    f.source !== null ||
    f.unassigned ||
    f.accountId !== null
  );
}
